import { SVGProps } from 'react';

const Landmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 18v-7m4 7v-7m4 7v-7M3 22h18M6 18v-7m5.12-8.802a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.95-.22.95H3.474c-.53 0-.695-.717-.22-.95z"
    />
  </svg>
);
export default Landmark;
